import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {withExperiments} from 'wix-experiments-react';
import get from 'lodash/get';
import {serverApi} from 'chat-widget-common';
import UploadBar from '../UploadBar/UploadBar';
import File from '../../svgIcons/dist/components/file';

class Attachment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      url: null
    };
  }

  componentDidMount() {
    const {media, uploading} = this.props;
    if (!uploading) {
      this.setDownloadUrlFromServer(media);
    }
  }

  componentWillReceiveProps(nextProps) {
    const {uploading} = this.props;
    if (!nextProps.uploading && uploading) {
      this.setDownloadUrlFromServer(nextProps.media);
    }
  }

  setDownloadUrlFromServer(media) {
    const {url} = media;
    serverApi.getAttachment({url})
      .then(res => {
        const {url} = res;
        this.setState({url});
      });
  }

  render() {
    const {chatSettings, media, uploading} = this.props;
    const {url} = this.state;

    const name = get(media, 'file.name');
    const messageStyle = {
      borderRadius: get(chatSettings, 'design.selectedRadiusOption') + 'px'
    };

    // todo check name
    const attachment = <span> <File size="17px"/> <span className="file-name"> {name || media.name} </span> </span>;

    function getHtml() {
      if (url) {
        return (
          <div className="message-content" style={messageStyle}>
            <a href={url} target="_blank" rel="noopener noreferrer">
              {attachment}
            </a>
          </div>
        );
      } else if (uploading) {
        return (
          <span className="attachment-with-upload">
            <div className="message-content" style={messageStyle}>
              {attachment}
            </div>
            <UploadBar percentCompleted={media.percentCompleted}/>
          </span>
        );
      } else {
        return (
          <div className="message-content" style={messageStyle}>
            {attachment}
          </div>
        );
      }
    }

    return (
      <div className="attachment-container">

        <div className={`attachment ${uploading ? 'uploading' : ''}`} style={messageStyle}>
          {
            getHtml()
          }
        </div>
      </div>
    );
  }
}

Attachment.propTypes = {
  media: PropTypes.object,
  chatSettings: PropTypes.object,
  uploading: PropTypes.bool
};

function mapStateToProps(state) {
  return {
    chatSettings: state.chatSettings
  };
}

export default withExperiments(connect(mapStateToProps)(Attachment));



// WEBPACK FOOTER //
// ./chat-app/components/Attachment/Attachment.js